import { useSectionData } from '../hooks/dataContext';

export const getTitlename = (key: string, value: any) => {
  switch (key) {
    case 'tenantInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          return 'Your Information';
        }
      }
      break;
    case 'tenantAlternateInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          return 'Alternate Contact Information';
        }
      }
      break;
    case 'tenantDriversLicenseInfo':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          return 'Driver License Information';
        }
      }
      break;
    case 'militaryInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          return 'Military Information';
        }
      }
      break;
    case 'moveInDetails':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          return 'Move-In Details';
        }
      }
      break;
    default:
      return '';
  }
};
export const updatedDateFormat = (newData: any) => {
  if (typeof newData === 'object') {
    const zone = (n: string | number) => ('0' + n).slice(-2);
    const zz = (n: string | number) => ('00' + n).slice(-3);
    let offset = newData.getTimezoneOffset();
    let sign = offset > 0 ? '-' : '+';
    offset = Math.abs(offset);

    let newDate =
      newData.getFullYear() +
      '-' +
      zone(newData.getMonth() + 1) +
      '-' +
      zone(newData.getDate()) +
      'T' +
      zone(newData.getHours()) +
      ':' +
      zone(newData.getMinutes()) +
      ':' +
      zone(newData.getSeconds()) +
      '.' +
      zz(newData.getMilliseconds()) +
      sign +
      zone((offset / 60) | 0) +
      ':' +
      zone(offset % 60);
    newDate = newDate.split('T')[0];
    const updatedDate = newDate.split('-');
    return `${updatedDate[1]}-${updatedDate[2]}-${updatedDate[0]}`;
  } else {
    // newData = newData.split('-');
    // return `${newData[1]}-${newData[2]}-${newData[0]}`;
    return newData;
  }
};
export const getFieldsData = (
  key: string,
  value: any,
  arrayData: { key: string; label: string; value: any }[]
) => {
  arrayData = [];
  const arrayDataHelper = (key: string, label: string, value: any) => {
    if (value !== undefined || value !== '') {
      arrayData.push({
        key,
        label,
        value,
      });
    }
  };
  switch (key) {
    case 'tenantInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          arrayDataHelper('tenantInfo', item, value[item]);
        }
      }
      break;
    case 'tenantAlternateInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          arrayDataHelper('alternateInfo', item, value[item]);
        }
      }
      break;
    case 'tenantDriversLicenseInfo':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          arrayDataHelper('dlInfo', item, value[item]);
        }
      }
      break;
    case 'militaryInformation':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          arrayDataHelper('militaryInfo', item, value[item]);
        } else {
          delete value[item];
        }
      }
      break;

    case 'moveInDetails':
      for (let item in value) {
        if (value[item] !== undefined || value[item] !== '') {
          arrayDataHelper('moveInDetails', item, value[item]);
        }
      }
      break;
  }

  return arrayData;
};

export const getUpdatedFormData = (formData: any, path: string) => {
  let tenantInformation: any = {};
  let tenantAlternateInformation: any = {};
  let tenantDriversLicenseInfo: any = {};
  let militaryInformation: any = {};
  let moveInDetails: any = {};
  const newFormData = formData;
  const data = useSectionData();
  const { setTenantUserName, setTenantUserPassword } = data;
  setTenantUserName(newFormData['OtherInfo_EmailAddress']);
  setTenantUserPassword(newFormData['OtherInfo_ConfirmPassword']);

  for (let info in newFormData) {
    if (info.includes('TenantInfo')) {
      (newFormData['TenantInfo_FirstName'] ||
        newFormData['TenantInfo_LastName']) !== undefined &&
        (tenantInformation['Name'] = `${newFormData['TenantInfo_FirstName'] ||
          ''} ${newFormData['TenantInfo_LastName'] || ''}`);

      newFormData['TenantInfo_EmailAddress'] !== undefined &&
        (tenantInformation['Email'] = newFormData['TenantInfo_EmailAddress']);

      newFormData['TenantInfo_CellPhone'] !== undefined &&
        (tenantInformation['Phone Number'] =
          newFormData['TenantInfo_CellPhone']);

      (newFormData['TenantInfo_AddressLine1'] ||
        newFormData['TenantInfo_AddressLine2'] ||
        newFormData['TenantInfo_City'] ||
        newFormData['TenantInfo_StateProvince'] ||
        newFormData['TenantInfo_PostalCode']) !== undefined &&
        (tenantInformation['Address'] = `${newFormData[
          'TenantInfo_AddressLine1'
        ] || ''} ${newFormData['TenantInfo_AddressLine2'] || ''} ${newFormData[
          'TenantInfo_City'
        ] || ''} ${newFormData['TenantInfo_StateProvince'] || ''} ${newFormData[
          'TenantInfo_PostalCode'
        ] || ''}`);

      newFormData['TenantInfo_BirthDate'] !== undefined &&
        (tenantInformation['Date of Birth'] = updatedDateFormat(
          newFormData['TenantInfo_BirthDate']
        ));
      newFormData['TenantInfo_DesiredMoveInDate'] !== undefined
        ? (moveInDetails['Move-In Date'] = updatedDateFormat(
            newFormData['TenantInfo_DesiredMoveInDate']
          ))
        : (moveInDetails['Move-In Date'] = updatedDateFormat(new Date()));

      newFormData['TenantInfo_DriverLicenseNumber'] !== undefined &&
        (tenantDriversLicenseInfo['License Number'] =
          newFormData['TenantInfo_DriverLicenseNumber']);

      newFormData['TenantInfo_DriversLicenseExpirationDate'] !== undefined &&
        (tenantDriversLicenseInfo[
          'License Expiration Date'
        ] = updatedDateFormat(
          newFormData['TenantInfo_DriversLicenseExpirationDate']
        ));

      newFormData['TenantInfo_StateId'] !== undefined &&
        (tenantDriversLicenseInfo['State Id'] =
          newFormData['TenantInfo_StateId']);

      newFormData['TenantInfo_SSN'] !== undefined &&
        (tenantDriversLicenseInfo['SSN'] = newFormData['TenantInfo_SSN']);
    } else if (info.includes('AlternateInfo')) {
      (newFormData['AlternateInfo_FirstName'] ||
        newFormData['AlternateInfo_LastName']) !== undefined &&
        (tenantAlternateInformation['Name'] = `${newFormData[
          'AlternateInfo_FirstName'
        ] || ''} ${newFormData['AlternateInfo_LastName'] || ''}`);

      newFormData['AlternateInfo_EmailAddress'] !== undefined &&
        (tenantAlternateInformation['Email'] =
          newFormData['AlternateInfo_EmailAddress']);

      newFormData['AlternateInfo_PhoneNumber'] !== undefined &&
        (tenantAlternateInformation['Phone Number'] =
          newFormData['AlternateInfo_PhoneNumber']);

      newFormData['AlternateInfo_HomeNumber'] !== undefined &&
        (tenantAlternateInformation['Home Number'] =
          newFormData['AlternateInfo_HomeNumber']);

      (newFormData['AlternateInfo_AddressLine1'] ||
        newFormData['AlternateInfo_AddressLine2'] ||
        newFormData['AlternateInfo_City'] ||
        newFormData['AlternateInfo_StateProvince'] ||
        newFormData['AlternateInfo_PostalCode']) !== undefined &&
        (tenantAlternateInformation['Address'] = `${newFormData[
          'AlternateInfo_AddressLine1'
        ] || ''} ${newFormData['AlternateInfo_AddressLine2'] ||
          ''} ${newFormData['AlternateInfo_City'] || ''} ${newFormData[
          'AlternateInfo_StateProvince'
        ] || ''} ${newFormData['AlternateInfo_PostalCode'] || ''}`);

      newFormData['AlternateInfo_Relationship'] !== undefined &&
        (tenantAlternateInformation['Relation'] =
          newFormData['AlternateInfo_Relationship']);
    } else if (info.includes('OtherInfo')) {
      newFormData['OtherInfo_MilitaryType'] !== undefined &&
        (militaryInformation['Military Type'] =
          newFormData['OtherInfo_MilitaryType']);

      newFormData['OtherInfo_MilitaryBranch'] !== undefined &&
        (militaryInformation['Military Branch'] =
          newFormData['OtherInfo_MilitaryBranch']);

      newFormData['OtherInfo_MilitaryID'] !== undefined &&
        (militaryInformation['Military ID'] =
          newFormData['OtherInfo_MilitaryID']);

      newFormData['OtherInfo_MilitaryDeployedUntilDate'] !== undefined &&
        (militaryInformation['Military Deployed Until'] = updatedDateFormat(
          newFormData['OtherInfo_MilitaryDeployedUntilDate']
        ));

      newFormData['OtherInfo_MilitaryDivisionUnit'] !== undefined &&
        (militaryInformation['Military Division'] =
          newFormData['OtherInfo_MilitaryDivisionUnit']);

      newFormData['OtherInfo_MilitaryCommandingOfficer'] !== undefined &&
        (militaryInformation['Military Commanding Officer'] =
          newFormData['OtherInfo_MilitaryCommandingOfficer']);

      newFormData['OtherInfo_MilitaryCOPhone'] !== undefined &&
        (militaryInformation['Military C.O Phone'] =
          newFormData['OtherInfo_MilitaryCOPhone']);
    }
  }
  if (path.includes('reserve')) {
    return {
      tenantInformation,
      moveInDetails,
    };
  } else if (path.includes('move-in')) {
    return {
      tenantInformation,
      tenantAlternateInformation,
      tenantDriversLicenseInfo,
      militaryInformation,
      moveInDetails,
    };
  }
};
